// extracted by mini-css-extract-plugin
export default {"metrics-box":"metrics-box_metrics-box__bLvtk"};